export const TOKEN_EXPLORER_OPTIONS = {
  tab: [
    {
      label: 'Trending',
      value: 'trending',
    },
    {
      label: 'Gemspump',
      value: 'gemspump',
    },
    {
      label: 'Followed',
      value: 'followed',
      disabledForNotLogged: true,
    },
  ],
  time: [
    {
      label: '15m',
      value: '15m',
    },
    {
      label: '1h',
      value: '1h',
    },
    {
      label: '24h',
      value: '24h',
    },
    {
      label: '7d',
      value: '7d',
    },
    {
      label: '28d',
      value: '28d',
    },
  ],
  view: [
    
      {
        label: 'List',
        value: 'list',
        icon: 'icons/advanced-list-icon.svg',
      },
      {
        label: 'OG',
        value: 'grid',
        icon: 'icons/classic-list-icon.svg',
      },
  ],
  sortBy: [
    {
      label: 'Volume',
      value: 'volume',
    },
    {
      label: 'Market Cap',
      value: 'marketcap',
    },
  ],
  chain: [
    {
      label: 'All',
      value: 'all',
      icon: '/images/all-chains.svg',
    },
    {
      label: 'Flare',
      value: '14',
      icon: '/images/flare-logo.svg',
    },
    {
      label: 'Pulse',
      value: '369',
      icon: '/images/pulsechain-logo.svg',
    },
  ]
}
